import { type FunctionComponent } from 'react';
import { MAX_PAGE_WIDTH } from '../../../../constants/breakpoints';
import { FAQ_DATA } from '../../../../constants/project/about-page';
import { type ToolsTabData, type FaqTabData } from '../../../../types/project-about.types';
import { ProjectsAccordion } from '../projects-accordion/projects-accordion.component';
import { faqSectionHeight } from './about-page-faq.css';

export const AboutPageFAQ: FunctionComponent = () => {
	const getContent = (item: FaqTabData | ToolsTabData): JSX.Element => {
		if ('answer' in item) {
			return <p className="f5 theme-grey-dark mt0 mb3 lh-copy">{item.answer}</p>;
		}
		return <p className="mt0 mb3 lh-copy">No answer available.</p>;
	};
	const getTitle = (item: FaqTabData | ToolsTabData): string => {
		if ('question' in item) {
			return item.question;
		}
		return 'No question available';
	};

	return (
		<section className={`flex flex-column items-center w-100 ph3 ph0-ns bg-theme-primary-lighter ${faqSectionHeight}`}>
			<div className="mb6 ph3-ns" style={{ maxWidth: MAX_PAGE_WIDTH }}>
				<h2 className="f2 mv4">Frequently Asked Questions</h2>
				<div className="br2 shadow-3 bg-theme-white">
					<ProjectsAccordion data={FAQ_DATA} getContent={getContent} getTitle={getTitle} />
				</div>
			</div>
		</section>
	);
};
